class CartRewards extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick = (event) => {
      const button = event.target.closest('[data-variant]');
      if (button) this.addProduct(button);
    });
    this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
  }

  disconnectedCallback() {
    this.unsubscribe?.();
    this.controller?.abort();
    this.removeEventListener('click', this.onClick);
  }

  async refresh() {
    this.controller?.abort();
    this.controller = new AbortController();
    try {
      const url = new URL(routes.cart_url, window.location.origin);
      url.searchParams.set('section_id', this.dataset.section);
      const response = await fetch(url, { signal: this.controller.signal });
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const updated = html.querySelector('cart-rewards');
      if (updated && this.isConnected) this.innerHTML = updated.innerHTML;
      else if (this.isConnected) this.replaceChildren();
    } catch (error) {
      if (error.name !== 'AbortError') console.error('Unable to refresh cart recommendations.', error);
    }
  }

  async addProduct(button) {
    if (CartRewards.busy) return;
    CartRewards.busy = true;
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    const errorMessage = this.querySelector('.cart-addon-error');
    errorMessage.hidden = true;
    const drawer = document.querySelector('cart-drawer');
    const inDrawer = Boolean(this.closest('cart-drawer'));
    const pageItems = document.getElementById('main-cart-items');
    const pageFooter = document.getElementById('main-cart-footer');
    const sections = ['cart-icon-bubble'];
    if (drawer) sections.push('cart-drawer');
    if (pageItems) sections.push(pageItems.dataset.id);
    if (pageFooter) sections.push(pageFooter.dataset.id);
    let added = false;
    try {
      const response = await fetch(routes.cart_add_url, {
        ...fetchConfig('javascript'),
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variant), quantity: 1 }],
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'This item could not be added. Please try again.');
      added = true;
      // A successful add can still return null section HTML. Never repeat the add.
      if (sections.some((id) => !result.sections?.[id])) {
        window.location.assign(routes.cart_url);
        return;
      }
      const parsedSections = new Map(sections.map((id) => [id, new DOMParser().parseFromString(result.sections[id], 'text/html')]));
      for (const [element, selector] of [[pageItems, '.js-contents'], [pageFooter, '.js-contents']]) {
        if (!element) continue;
        const updated = parsedSections.get(element.dataset.id).querySelector(selector);
        const target = element.querySelector(selector);
        if (!updated || !target) throw new Error('Unable to refresh cart.');
        target.innerHTML = updated.innerHTML;
        element.classList.remove('is-empty');
      }
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble) bubble.innerHTML = parsedSections.get('cart-icon-bubble').querySelector('.shopify-section').innerHTML;
      if (drawer) {
        drawer.classList.remove('is-empty');
        if (inDrawer) {
          drawer.renderContents(result);
        } else {
          const updated = parsedSections.get('cart-drawer').querySelector('#CartDrawer');
          drawer.querySelector('#CartDrawer').innerHTML = updated.innerHTML;
          drawer.querySelector('#CartDrawer-Overlay').addEventListener('click', () => drawer.close());
        }
      }
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: result, variantId: Number(button.dataset.variant) });
      const focusTarget = inDrawer ? drawer.querySelector('.drawer__close') : pageFooter?.querySelector('[data-variant]') || document.getElementById('checkout');
      focusTarget?.focus();
    } catch (error) {
      if (added) {
        window.location.assign(routes.cart_url);
      } else {
        errorMessage.textContent = error.message || 'Could not add this item. Please try again.';
        errorMessage.hidden = false;
      }
    } finally {
      CartRewards.busy = false;
      button.disabled = false;
      button.textContent = originalText;
    }
  }
}
customElements.define('cart-rewards', CartRewards);
